export default __webpack_public_path__ + "static/media/013-bowling.28477dbf.svg";